import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=9c65aa6a&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"
import style0 from "./downLoad.vue?vue&type=style&index=0&id=9c65aa6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c65aa6a",
  null
  
)

export default component.exports